import { FitFinderUI } from "./FitFinderUI";
import { StandardProps } from "../componentMap";
import { useVariant } from "@/hooks/useVariant/useVariant.ts";
import {
  getBreadCrumbs,
  includedCategories,
  isFeatureEnabledForCategory,
  normalizeImageUrl,
} from "./FitFinderUtils";

import { trimEnd } from "lodash";

export function FitFinder({
  product,
  runtimeConfig,
}: Pick<StandardProps, "product" | "runtimeConfig">) {
  const { variant } = useVariant(product);

  const breadCrumbs = getBreadCrumbs(product);

  const braCategory = breadCrumbs?.find(
    (category) => category.value?.toLowerCase()?.indexOf("bras") > -1,
  );

  const isFeatureEnabled = isFeatureEnabledForCategory(
    breadCrumbs,
    includedCategories,
  );

  if (
    braCategory ||
    product.__typename !== "SimpleProduct" ||
    !isFeatureEnabled
  )
    return null;

  const { skuId } = variant.aliases;
  const brand = product.brand?.name || "";
  const alternatives = variant.images.alternatives || [];
  const mainThumbNail =
    [variant.images.primary, ...alternatives]
      .filter(Boolean)
      .map(normalizeImageUrl)[0] || "";
  const currentPrice = variant.price?.value || "";
  const pimProductId = product.aliases?.pimProductId;
  const currentColor = trimEnd(
    variant.differentiators?.colour || variant.colour?.trueColour || "",
  );

  const currentDifferentiatorsColour = variant.differentiators?.colour || null;

  const sizes = product.variants
    .filter(
      (variant) =>
        variant.differentiators?.size &&
        variant.differentiators?.colour === currentDifferentiatorsColour,
    )
    .map((variant) => ({
      value: variant.differentiators?.size || "",
      isAvailable: variant.availability.availableToOrder,
    }));
  const skuTitle = variant.differentiators?.colour
    ? product.title + ", " + variant.differentiators.colour
    : product.title;
  const fitFinderUrl = runtimeConfig.fitFinderUrl;
  return (
    <FitFinderUI
      mainThumbnail={mainThumbNail}
      currentColour={currentColor}
      sizes={sizes}
      brand={brand}
      price={currentPrice}
      crumbs={breadCrumbs}
      skuTitle={skuTitle}
      productId={pimProductId}
      currentSkuId={skuId}
      fitFinderUrl={fitFinderUrl}
    />
  );
}
